export enum AuthErrors {
  INVALID_CREDENTIALS = 401000,
  ACCOUNT_LOCKED = 4230001
}
